import { LogoMark } from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <LogoMark size={28} />
            <span className="font-display font-bold tracking-[0.25em] text-white text-xs">
              NEVER BETTER — THE JOE FENIX METHOD
            </span>
          </div>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#858599]">
            Protocollo v1.0 — © 2026 Joe Fenix Method
          </span>
        </div>
        <p
          data-testid="footer-disclaimer"
          className="mt-8 text-xs leading-relaxed text-[#858599] max-w-3xl"
        >
          Disclaimer Scientifico: il metodo Joe Fenix e i protocolli di
          ingegneria somatica qui descritti sono concepiti per l'ottimizzazione
          delle performance psico-fisiologiche e presentati come narrativa del
          metodo. Non costituiscono parere medico, diagnosi o terapia e non
          sostituiscono il consulto di un professionista sanitario.
        </p>
      </div>
    </footer>
  );
}
